<template>
  <div class="calendar-view">
    <div class="calendar-header">
      <div class="button" @click="switchMonth(-1)">
        <img src="@/assets/image/left.png" width="15px" height="15px" alt="" />
      </div>
      <div class="date">{{ currentMonthText }}</div>
      <div class="button" @click="switchMonth(1)">
        <img src="@/assets/image/right.png" width="15px" height="15px" alt="" />
      </div>
    </div>
    <div class="calendar-wraper">
      <van-calendar
        :show-title="false"
        :poppable="false"
        :show-confirm="false"
        :show-subtitle="false"
        :show-mark="false"
        :row-height="50"
        :min-date="currentMonthMinDate"
        :max-date="currentMonthMaxDate"
        @select="onDateSelect"
      >
        <template slot="bottom-info" slot-scope="day">
          <span v-if="hasShowStar(day)">
            <van-icon name="star" color="#d20000" />
          </span>
        </template>
      </van-calendar>
    </div>
  </div>
</template>

<script>
import moment from "moment";

export default {
  props: {
    defauleMonth: {
      type: String,
      default: moment().format("YYYY-MM")
    },
    hasShowStar: {
      type: Function,
      default: () => {
        return false;
      }
    },
    switchMonthCallback: {
      type: Function,
      default: () => {
        return new Promise(resolve => {
          resolve();
        });
      }
    }
  },
  //   model: {
  //     prop: "value",
  //     event: "update",
  //   },
  data() {
    return {
      currentMonth: moment()
    };
  },
  computed: {
    currentMonthText() {
      return moment(this.currentMonth).format("YYYY年MM月");
    },
    currentMonthMinDate() {
      const date = moment(this.currentMonth)
        .startOf("month")
        .format("YYYY-MM-DD");
      return new Date(date);
    },
    currentMonthMaxDate() {
      const date = moment(this.currentMonth)
        .endOf("month")
        .format("YYYY-MM-DD");
      return new Date(date);
    }
  },
  created() {
    this.currentMonth = moment(this.defauleMonth);
  },
  methods: {
    switchMonth(val) {
      const { currentMonth } = this;
      const newMonth = currentMonth.add(val, "month");
      if (this.switchMonthCallback) {
        this.switchMonthCallback(newMonth).then(() => {
          this.currentMonth = "";
          this.currentMonth = newMonth;
        });
      }
    },
    onDateSelect(day) {
      const date = moment(day).format("YYYY-MM-DD");
      this.$emit("dateSelect", date);
    }
  }
};
</script>

<style lang="less" scoped>
.calendar-view {
  .calendar-header {
    position: relative;
    border-radius: 7px;
    background-color: rgb(248, 248, 248);
    margin-bottom: 5px;
    display: flex;
    .date {
      text-align: center;
      flex: 1;
      line-height: 50px;
    }
    .button {
      padding: 12px 16px;
      line-height: 1;
      line-height: 1;
      align-items: center;
      display: flex;
    }
  }
  /deep/.van-calendar__month-title {
    display: none;
  }
  /deep/.van-calendar__day {
    display: block;
    line-height: 30px;
    font-size: 16px;
    .van-calendar__bottom-info {
      bottom: 5px;
      .van-icon {
        font-size: 12px;
      }
    }
  }
  /deep/.van-calendar__selected-day {
    display: block;
    line-height: 32px;
    width: 100% !important;
    .van-calendar__bottom-info {
      .van-icon {
        color: #fff !important;
      }
    }
  }
  /deep/.van-calendar__header {
    box-shadow: none;
    .van-calendar__weekdays {
      .van-calendar__weekday {
        margin: 2px;
        background: #f8f8f8;
        border-radius: 4px;
        font-size: 12px;
        position: relative;
        &::after {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          line-height: 31px;
          background: #f8f8f8;
          border-radius: 4px;
        }
        &:nth-child(1)::after {
          content: "星期日";
        }
        &:nth-child(2)::after {
          content: "星期一";
        }
        &:nth-child(3)::after {
          content: "星期二";
        }
        &:nth-child(4)::after {
          content: "星期三";
        }
        &:nth-child(5)::after {
          content: "星期四";
        }
        &:nth-child(6)::after {
          content: "星期五";
        }
        &:nth-child(7)::after {
          content: "星期六";
        }
      }
    }
  }
  /deep/.van-calendar__days {
    background: linear-gradient(90deg, #f2f2f2 1%, transparent 0%) 0 0;
    background-size: 49px 50px;
  }
}
</style>
